import find from "lodash/find";

import { Box } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const Footer = (): JSX.Element => {
  const { liquidTemplates } = useAppSelector((state) => state.liquidTemplates);

  const node = find(
    liquidTemplates,
    (template) => template.path === "liquid_templates/footer"
  );

  if (node) {
    const { body } = node;

    return (
      <Box
        dangerouslySetInnerHTML={{
          __html: body
        }}
      />
    );
  }

  return null;
};

export default Footer;
